import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";
import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";

function SaltoOpenLockFormView({
  relations,
  selectedStep,
  selectedStepIndex,
  saltoLockLabels,
  onLockChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.steps.*.salto_lock_id",
        )}
        required
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.salto_lock_id`,
          submitError,
        )}
      >
        <Select
          value={selectedStep?.salto_lock_id}
          options={relations?.salto_config?.data?.locks?.map((configLock) => ({
            label: saltoLockLabels[configLock.lock_id],
            value: configLock.id,
          }))}
          onChange={onLockChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default SaltoOpenLockFormView;
